import axios from 'axios';
import qs from 'qs';

export default class DealService {
  static async getDeals({ model, modelId }, options = {}) {
    let query;

    if (model && modelId) {
      query = {
        filter: {
          [`${model.toLowerCase()}_id`]: {
            '=': modelId,
          },
          stage_of_sale: {
            '>': 2,
          },
        },
      };
    } else {
      query = {
        filter: {
          id: {
            '=': modelId,
          },
          stage_of_sale: {
            '>': 2,
          },
        },
      };
    }

    const response = await axios.post('deals', query, {
      signal: options.signal,
    });

    return response.data;
  }

  static async getOptimizedDeals({ model, modelId, page, per_page: perPage }) {
    let query;

    if (model && modelId) {
      query = {
        filter: {
          [`${model.toLowerCase()}_id`]: {
            '=': modelId,
          },
          stage_of_sale: {
            '>': 2,
          },
        },
      };
    } else {
      query = {
        filter: {
          id: {
            '=': modelId,
          },
          stage_of_sale: {
            '>': 2,
          },
        },
      };
    }

    const res = await axios.post(
      `deals/customer?page=${page}&per_page=${perPage}`,
      query,
    );

    return res.data;
  }

  static async getDeal(id, { signal } = {}) {
    const response = await axios.get(`deals/${id}`, { signal });
    return response.data;
  }

  static async createDeal(data) {
    const response = await axios.post('deals', {
      data,
    });
    return response.data;
  }

  static async updateDeal(id, data) {
    const response = await axios.put('deals/id', {
      data,
    });
    return response.data;
  }

  static async deleteDeal(id) {
    const response = await axios.delete(`deals/${id}`);
    return response.data;
  }

  static async getPossibleStatuses() {
    const response = await axios.get('deals/possible-statuses');
    return response.data;
  }

  static async getPossibleTypes() {
    const response = await axios.get('dealType');
    return response.data;
  }

  static async lookForDeals(lookupData) {
    const response = await axios.post('deal/lookup', lookupData);
    return response.data;
  }

  static async getSalesPersonInfo(dealId) {
    const response = await axios.get(`deal/${dealId}/info/sales-person`);
    return response.data;
  }

  static async getDeletedDeals() {
    return (await axios.get('deals/deleted?per_page=1000')).data;
  }

  static async restoreDeletedDeal(dealId) {
    return axios.patch(`deal/${dealId}`);
  }

  static async changeCompany(dealId, companyId) {
    return (
      await axios.put(`/deal/${dealId}/companyId`, {
        company_id: companyId,
      })
    ).data;
  }

  static async fetchCustomerInfo(dealId, signal) {
    const response = await axios.get(`deal/${dealId}/info/customer`, {
      signal,
    });
    return response?.data ?? null;
  }

  static async fetchSystemsList(dealId, signal) {
    const response = await axios.get(`deal/${dealId}/info/systems-list`, {
      signal,
    });
    return response?.data ?? null;
  }

  static async getSystems(dealId) {
    const response = await axios.get(`deal/${dealId}/info/systems`);
    return response.data;
  }

  static async deleteSystem(dealSystemId) {
    const response = await axios.delete(`deal-system/${dealSystemId}`);
    return response.data;
  }

  static async verifyPasscode(dealId, dealSystemId, passcode) {
    const response = await axios.post('deal/passcodeTest', {
      dealId,
      passcode,
      deal_system_id: dealSystemId,
    });
    return response.data;
  }

  static async addSystem(dealId, newSystemType) {
    return axios.post('deal-system/add-new-system-type', {
      deal_id: dealId,
      new_system_type: newSystemType,
    });
  }

  static async changeSystemType(dealSystemId, newSystemType, confirm) {
    return axios.post('deal-system/change-system-type', {
      deal_system_id: dealSystemId,
      new_system_type: newSystemType,
      accept_changes: confirm,
    });
  }

  static async updateSystemName(dealSystemId, systemName) {
    return axios.put('deal-system/update-system-name', {
      deal_system_id: dealSystemId,
      system_changable_name: systemName,
    });
  }

  static async getDealOverview(params = null) {
    const path = params.custom_path ?? 'deals';

    return (
      await axios.post(
        path,
        {},
        {
          params: {
            ...params,
            filter: params
              ? {
                  ...params.filter,
                  ['stage_of_sale']: {
                    ['>']: 2,
                  },
                }
              : {},
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        },
      )
    ).data;
  }
}
